import * as React from 'react';
import { IconTooltip, IconTooltipProps } from '~/ui-components/IconToolTip';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';

export type InfoTooltipProps = Omit<IconTooltipProps, 'children' | 'icon'>;

export function InfoTooltip({ ...props }: Readonly<InfoTooltipProps>) {
   return <IconTooltip icon={faCircleInfo} {...props} />;
}
